import {
    SiCplusplus,
    SiFramer,
    SiGithub, SiNeovim,
    SiNextdotjs,
    SiReact,
    SiRust,
    SiTailwindcss,
    SiTypescript,
    SiZig
} from "react-icons/si";
import {IconType} from "react-icons";

export type ProjectProps = {
  id: number;
  name: string;
  description: string;
  technologies: IconType[];
  techNames: string[];
  techLinks: string[];
  github: string;
  demo: string;
  image: string;
  available: boolean;
};

export const projects = [
    {
        id: 0,
        name: "Toetspers Vulnerabilities",
        description:
            "Found multiple zero day vulnerabilities in the Toetspers Digital Examination Software. Responsible for the full stack development of a proof of concept exploit The exploit was able to bypass all security measures implemented by Toetspers, including sandboxing and anti-debugging techniques. And allowed for viewing the exam content, including questions and answers, without detection. And allowing for studens to use LLMs to answer the questions. ",
        technologies: [SiTypescript, SiCplusplus],
        techNames: ["TypeScript", "C++"],
        techLinks: ["https://www.typescriptlang.org/", "https://www.cplusplus.com/"],
        github: "https://github.com/nuIIpointerexception/www.digitalimaginations.org",
        demo: "https://www.digitalimaginations.org/",
        image: "/projects/portfolio.webp",
        available: true,
    },
    {
        id: 1,
        name: "Coming Soon",
        description:
            "I'm currently working on a couple of projects. I'll update this section as soon as I'm done.",
        technologies: [SiCplusplus],
        techNames: ["C++"],
        techLinks: ["https://www.cplusplus.com/"],
        github: "https://github.com/nuIIpointerexception/",
        demo: "https://github.com/nuIIpointerexception/",
        image: "/projects/construction.webp",
        available: false,
    },
];
